export function formatSeconds(sec) {
  return Math.ceil(sec / 60) + ' min'
}

export function deepClone(o) {
  return JSON.parse(JSON.stringify(o))
}
